<!-- <app-course-header></app-course-header> -->

<div class="UNFAPP-signlog-full-area">
    <!--<div class="UNFAPP-arrow-otpscreen UNFAPP-d-hide"><a class="UNFAPP-otp-numbr-edit" (click)='editNum()'>
        <img src="assets/img/Combined-Shape.svg" alt=""></a></div>-->
    <div class="UNFAPP-signlog-frm-wrpbx">
        <div class="UNFAPP-signlog-frmbx">
            <div class="UNFAPP-signlog-hdng-wrap">
                <h2 class="UNFAPP-signlog-hdng">Welcome to Infinity Learn</h2>
                <h3 class="UNFAPP-signlog-stphdng">You are 2 steps away from starting your learning journey</h3>
            </div>

            <div class="UNFAPP-loginvia-sectn smsp">
                <div class="UNFAPP-otp-img">
                    <img src="assets/img/otp-icon.svg" alt="" />
                </div>
                <div class="UNFAPP-loginvia-hdngarea UNFAPP-verify">
                    <h3 class="UNFAPP-loginvia-hdng UNFAPP-headingalign">Verify OTP</h3>
                    <h4 class="UNFAPP-loginvia-subhdng UNFAPP-headingalign">
                        <span class="UNFAPP-lgh-text UNFAPP-headingalign">Please verify the OTP sent to </span>
                        <span class="UNFAPP-otp-numbr UNFAPP-headingalign">{{userData?.dialCode }}
                            {{userData.number ?  userData.number : userData.phone}}</span>
                            <a class="UNFAPP-otp-numbr-edit UNFAPP-m-hide" (click)='editNum()'>EDIT</a>
                        </h4>
                    <h4 class="UNFAPP-loginvia-subhdng UNFAPP-otp-expire-desk UNFAPP-headingalign">OTP Expires in 15 mins</h4>
                </div>
                <div class="UNFAPP-loginvia-fromarea">
                    <div class="UNFAPP-form-fld-row">
                        <div class="UNFAPP-form-fld-wrp UNFAPP-otp-fldwrap UNFAPP-otp-screen">
                            <!-- <input type="text" class="UNFAPP-form-fld">
                            <input type="text" class="UNFAPP-form-fld">
                            <input type="text" class="UNFAPP-form-fld">
                            <input type="text" class="UNFAPP-form-fld"> -->
                            <ng-otp-input (onInputChange)="onOtpChange($event)" id="otpboxes" [config]="config"></ng-otp-input>
                            
                        </div>
                        <label class="UNFAPP-fld-error text-center" *ngIf='optErr'>The OTP is incorrect, please enter again</label>
                    </div>
                    <div class="UNFAPP-loginvia-actnarea">
                        <button type="button" class="UNFAPP-blue-btn UNFAPP-full-btn" [disabled]='!otpValid' (click)="verifyOTP()">VERIFY OTP</button>
                    </div>
                    <div class="UNFAPP-logwthpass">
                        <div href="#" class="UNFAPP-otp-time" *ngIf='resendOtpBtn'>RESEND OTP IN <div>00:{{counter}}</div>
                        </div>
                        <a class="UNFAPP-txt-link" *ngIf='!resendOtpBtn' (click)='resendOtp()'>RESEND OTP</a>
                    </div>
                    <h4 class="UNFAPP-otp-expire">OTP Expires in 15 mins</h4>
                </div>
            </div>
    
        </div>
    </div>
</div>
<app-course-footer></app-course-footer>
